import { MatSnackBarDismiss } from '@angular/material/snack-bar';
import { Observable, of } from 'rxjs';

export class MockSnackbar {
  open = jasmine.createSpy('open').and.returnValue({
    afterDismissed: (): Observable<MatSnackBarDismiss> => of({ dismissedByAction: false })
  });
  dismiss = jasmine.createSpy('dismiss');
}
